module.exports = __webpack_public_path__ + "static/media/logos_50h_atal.e0f6b4c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_atal.jpg
// module id = 213
// module chunks = 0